import { useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { RegistrationFeedbackThankYou } from "@profile/components/organisms/RegistrationFeedbackThankYou/RegistrationFeedbackThankYou";
import type { RegisterFeedbackLocationState } from "@profile/components/registration-wizard/feedback/register-feedback.navigation";
import {
  registerFeedbackThankYouContentStyles,
  registerFeedbackThankYouPageStyles,
} from "./register-feedback.styles";

export function RegisterFeedbackThankYouPage() {
  const location = useLocation();
  const registeredEmail = (location.state as RegisterFeedbackLocationState | null)?.username;

  return (
    <div className={cn(registerFeedbackThankYouPageStyles())}>
      <div className={cn(registerFeedbackThankYouContentStyles())}>
        <RegistrationFeedbackThankYou username={registeredEmail} />
      </div>
    </div>
  );
}
